"use client";
import React, { Fragment } from "react";
import { Box } from "@chakra-ui/react";
import PageLayout from "@/layouts/pageLayout";
import PagesTabs from "@/components/pageTabs/tabs";
import { CLOUD_MIGRATION_CONSTANTS } from "@/components/header/header.constants";
import Hero from "./components/hero";
import IntroComponent from "./components/intro";
import MigrationComponent from "./components/migration";
import MigrationTable from "./components/scenarios";
import WhyMigrateToMost from "./components/whyMigrateToMost";
import ComparisonComponent from "./components/comparsion";
import MigrationCta from "./components/migrateCta";
import Faqs from "./components/faqs";

const VmWareMigrationPage = () => {
  return (
    <Fragment>
      <Box>
        <Hero />
        <PageLayout>
          <PagesTabs props={CLOUD_MIGRATION_CONSTANTS} />
          <IntroComponent />
        </PageLayout>
      </Box>
      <MigrationComponent />
      <PageLayout marginTop={0}>
        <MigrationTable />
      </PageLayout>
      <WhyMigrateToMost />
      <PageLayout showContactForm>
        <ComparisonComponent />
        <MigrationCta />
        <Faqs />
      </PageLayout>
    </Fragment>
  );
};

export default VmWareMigrationPage;
